module.exports = __webpack_public_path__ + "static/img/zhehoujia.c06865c8.png";